import { render, staticRenderFns } from "./ValidationInvitePage.vue?vue&type=template&id=f484b628&"
import script from "./ValidationInvitePage.vue?vue&type=script&lang=js&"
export * from "./ValidationInvitePage.vue?vue&type=script&lang=js&"
import style0 from "./ValidationInvitePage.vue?vue&type=style&index=0&id=f484b628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports